import * as React from 'react'
import Background from '../background/Background'
import { IWish, IStation, WishType } from 'types'
import { wishCategories } from '../wishes/wishes'
import { RouteComponentProps } from 'react-router'
import Title from '../titlte/Title'
import WishButton from '../buttons/WishButton'
import StationList from './StationList'
import { Link } from 'react-router-dom'
import { render } from 'react-dom'
import findNearestBikeStation from '../../lib/findNearestBikeSharing'
import findNearestCarSharing from '../../lib/findNearestCarSharing'
import findNearestStation from '../../lib/findNearestStation'
import { RematchRootState } from '@rematch/core'
import { models } from '../../store'
import { connect } from 'react-redux'
import StationItem from './StationItem'
import { ActivityIndicator, WhiteSpace } from 'antd-mobile'

interface StationOverviewProps extends ReturnType<typeof mapStateToProps> {}

const getWishConfigForType = (type: IWish['type']): IWish | undefined => {
  return wishCategories.find(wish => wish.type === type)
}

const textMap = (wishType: WishType) => {
  switch (wishType) {
    case 'scooter':
      return 'E-Scooter in der Nähe'
    case 'bike':
      return 'Fahrradstation in der Nähe'
    case 'car':
      return 'Carsharing-Station in der Nähe'
    case 'tram':
      return 'Straßenbahn-Haltestelle in der Nähe'
    case 'bike-lane':
      return 'Fahrradweg in der Nähe'
    case 'beer':
      return 'Bier in der Nähe'
    case 'bus':
      return 'Bussstation in der Nähe'
    case 'charging':
      return 'Auflademöglichkeit in der Nähe'
    case 'parking-lot':
      return 'Parkplatz in der Nähe'
    case 'safety':
      return '😕 scheinbar sollte es hier sicherer sein, erzähl uns was wir verbessern können'
  }
}

interface StationOverviewState {
  station: IStation | undefined
  alreadyLoaded: boolean
}

class StationOverview extends React.Component<
  StationOverviewProps & RouteComponentProps<{ type: string }>,
  StationOverviewState
> {
  constructor(props: StationOverviewProps & RouteComponentProps<{ type: string }>) {
    super(props)
    this.state = {
      station: undefined,
      alreadyLoaded: false,
    }
    this.getStation = this.getStation.bind(this)
  }

  private async getStation() {
    if (this.props.currentLocation && this.state.alreadyLoaded === false) {
      const pos = this.props.currentLocation
      let station: IStation | undefined

      switch (this.props.match.params.type as WishType) {
        case 'bike': {
          const res = await findNearestBikeStation({ lat: pos.lat, lng: pos.lng })
          station = {
            distance: res.distance,
            name: res.destination.name,
          }
          break
        }
        case 'car': {
          const res = await findNearestCarSharing({ lat: pos.lat, lng: pos.lng })
          station = {
            distance: res.existing.distance,
            name: res.existing.destination.name,
          }
          break
        }
        case 'tram': {
          const res = await findNearestStation({ lat: pos.lat, lng: pos.lng })
          station = {
            distance: res.distance,
            name: res.destination.name,
          }
          break
        }
      }

      this.setState({
        station,
        alreadyLoaded: true,
      })
    }
  }
  async componentDidUpdate() {
    await this.getStation()
  }

  async componentDidMount() {
    await this.getStation()
  }

  render() {
    const {
      match: { params },
    } = this.props
    const wish = getWishConfigForType(params.type as IWish['type'])

    if (!wish) {
      return null
    }

    return (
      <div style={{ height: '100vh', overflow: 'hidden' }}>
        <Background style={{ padding: '16px 16px 0 16px' }}>
          <div
            style={{
              position: 'relative',
              width: '100%',
              height: '100%',
              display: 'flex',
              flexDirection: 'column',
              flexGrow: 1,
            }}
          >
            <Title style={{ color: 'white' }} size="32px">
              {textMap(wish.type)}
            </Title>
            {wish.type === 'safety' || wish.type === 'bike-lane' ? null : (
              <StationList
                className="station"
                style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
              >
                {this.state.station == null ? (
                  <ActivityIndicator size="large" text="Nächste Station wird gesucht..." />
                ) : (
                  <StationItem name={this.state.station.name} distance={Math.round(this.state.station.distance)} />
                )}
              </StationList>
            )}
            <div
              style={{
                marginTop: 'auto',
                display: 'flex',
                flexDirection: 'column',
                color: 'white',
                marginBottom: '20px',
              }}
            >
              <Title size="24px" style={{ marginBottom: '10px' }}>
                {wish.type === 'safety' ? 'Was sollen wir ändern' : 'Nicht was du willst?'}
              </Title>
              <Link to={`/category/${wish.type}/wish`}>
                <WishButton>Wunsch äußern</WishButton>
              </Link>
            </div>
          </div>
        </Background>
      </div>
    )
  }
}

const mapStateToProps = (state: RematchRootState<models>) => ({
  currentLocation: state.wishes.currentLocation,
})

export default connect(mapStateToProps)(StationOverview)



// WEBPACK FOOTER //
// ./src/components/station/StationOverview.tsx